module.exports = __webpack_public_path__ + "static/img/图层55.6717cf0e.png";